import { render, staticRenderFns } from "./PatientGeneralPrint.vue?vue&type=template&id=5e67984f&"
import script from "./PatientGeneralPrint.vue?vue&type=script&lang=js&"
export * from "./PatientGeneralPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports